import {
  Card,
  CardActionButton,
  CardActionSection,
  CardActions,
  CardContent,
  CardContentMedia,
  CardFooter,
  CardFooterBadge,
  CardFooterDescription,
  CardFooterSection,
  CardFooterTitle,
} from "@opensea/ui-kit"

export const ItemCard = Card

export const ItemCardActions = CardActions
export const ItemCardActionButton = CardActionButton
export const ItemCardActionSection = CardActionSection

export const ItemCardContent = CardContent
export const ItemCardContentMedia = CardContentMedia
export const ItemCardFooter = CardFooter
export const ItemCardFooterSection = CardFooterSection
export const ItemCardFooterTitle = CardFooterTitle
export const ItemCardFooterDescription = CardFooterDescription
export const ItemCardFooterBadge = CardFooterBadge

export { ChainBadge as ItemCardChainBadge } from "./ChainBadge"
export { FavoriteItemBadge as ItemCardFavoriteItemBadge } from "./FavoriteItemBadge"
export { HiddenItemBadge as ItemCardHiddenItemBadge } from "./HiddenItemBadge"
export { ItemCardMedia } from "./ItemCardMedia"
export { ItemCardName } from "./ItemCardName"
export { ItemCardPriceLabel } from "./PriceLabel"
export { QuantityBadge as ItemCardQuantityBadge } from "./QuantityBadge"
export { RarityBadge as ItemCardRarityBadge } from "./RarityBadge"
export { SelectItemBadge as ItemCardSelectItemBadge } from "./SelectItemBadge"
export { SelectItemWithQuantityBadge as ItemCardSelectItemWithQuantityBadge } from "./SelectItemWithQuantityBadge"
export { TooltipButtonWrapper as ItemCardTooltipButtonWrapper } from "./TooltipButtonWrapper"
